import { BandsTypes } from "./Types";

export const ListOfBands = [
  BandsTypes.AGE,
  BandsTypes.GENDER,
  BandsTypes.ETHNICITY
];
export const APP_KEY = "feasibilityApp"; // Data map key
export const PATIENT_DETAILS = "demographics";
export const DATE_FEATURE = "date";
export const AGE_FEATURE = "age";
export const GENDER_FEATURE = "Sex";
export const ETHNIC_FEATURE = "ETHNIC";
export const AGE = "Age";
export const GENDER = "Gender";
export const ETHNIC = "Ethnicity";
export const BandHeaderText = {
  "Age": "OutputConfig.Banding.AgeHeader",
  "Gender": "OutputConfig.Banding.GenderHeader",
  "Ethnicity": "OutputConfig.Banding.EthnicHeader"
};
export const RANGE_FROM = "rangeFrom";
export const RANGE_TO = "rangeTo";
export const AGE_IS = ":age:is";
